import styled from '@emotion/styled';

import { PenLine } from '@features';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const MainTextStyled = styled.p`
  margin: 0;
  max-width: 770px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  ${getMediaqueryStyled('xl')} {
    max-width: 735px;
  }

  ${getMediaqueryStyled('lg')} {
    max-width: 485px;
  }

  ${getMediaqueryStyled('md')} {
    max-width: none;
  }
`;

export const TextUnbreakableNotMobile = styled.span`
  ${getMediaqueryStyled('sm')} {
    display: none;
  }
`;

export const TextBreakableMobile = styled.span`
  display: none;

  ${getMediaqueryStyled('sm')} {
    display: inline;
  }
`;

export const TextPenUnderlineFirst = styled(PenLine)`
  left: 36%;

  ${getMediaqueryStyled('xl')} {
    left: 50%;
    width: 181px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 124px;
  }

  ${getMediaqueryStyled('md')} {
    width: 166px;
  }

  ${getMediaqueryStyled('sm')} {
    display: none;
  }
`;

export const TextPenUnderlineFirstMobile = styled(PenLine)`
  display: none;

  ${getMediaqueryStyled('sm')} {
    display: block;
    width: 234px;
  }
`;

export const TextPenOutline = styled(PenLine)`
  ${getMediaqueryStyled('xl')} {
    width: 181px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 126px;
  }

  ${getMediaqueryStyled('md')} {
    width: 169px;
  }
`;

export const TextPenUnderlineSecond = styled(PenLine)`
  ${getMediaqueryStyled('xl')} {
    width: 286px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 202px;
  }

  ${getMediaqueryStyled('md')} {
    width: 268px;
  }

  ${getMediaqueryStyled('sm')} {
    display: none;
  }
`;

export const TextPenUnderlineSecondMobile = styled(PenLine)`
  display: none;

  ${getMediaqueryStyled('sm')} {
    display: block;
    width: 107px;
  }
`;
